import { faMemoCircleCheck } from "@fortawesome/pro-solid-svg-icons"
import { Grid, Typography, useTheme } from "@mui/material"
import { Box } from "@mui/system"
import { CircleIcon } from "components/icons/CircleIcon"
import React from "react"
import { useTranslation } from "react-i18next"

const WorkOrderTitle = ({ initialValues, title }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <Box display="flex" flexDirection="row">
      <CircleIcon
        icon={faMemoCircleCheck}
        backgroundColor={theme.palette.primary[300]}
        color={theme.palette.primary[800]}
        size="lg"
      />
      <Box order={2} pl={2} flexGrow={2}>
        <Grid item>
          <Typography variant="h2">
            {initialValues.id ? `#${initialValues.id}` : t("global.create_work_order", "Create work order")}
          </Typography>
          <Typography variant="bodySmall">
            {title ? `${title}` : t("global.workorder", "Work order")}
          </Typography>
        </Grid>
      </Box>
    </Box>
  )
}

export default WorkOrderTitle
